export const averageBreachCost = 4_880_000;

// Format a given amount to locale currency format (presentation), using browser's preferred language (if available), fallback to "en-US"
export function formatCurrency(
  amount: number,
  currency: string = "USD",
  locale?: string,
): string {
  if (!locale) {
    if (typeof navigator !== "undefined") {
      const nav = navigator as Navigator & {
        languages?: string[];
        language?: string;
      };
      locale = nav.languages?.[0] || nav.language || "en-US";
    } else {
      // Fallback for Bun / Node
      locale = "en-US";
    }
  }

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}
